import React from 'react'
import { useSelector } from 'react-redux'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { selectSelectedGeoentityIdentityCard } from '../../../store/geoentity/geoentity.selectors'
import ShareUrlButton from '../../genericComponents/ShareUrlButton'
// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(function GeoentitySharebutton() {
  const identityCard = useSelector(selectSelectedGeoentityIdentityCard)
  const address = identityCard?.address
  const poiName = identityCard?.name ?? 'Mappy'
  return <ShareUrlButton title={poiName} description={`${poiName}, ${address}`} />
})
